import styled from 'styled-components/macro'

export default styled.div`
  background-color: #fff;
  max-width: ${props => props.theme.maxWidth};
  position: fixed;
  top: 0;
  bottom:0;
  left: 0;
  right: 0;
  z-index: 5;
  margin: auto;
`
